import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import AssetsContext from '../contexts/assets-context';
import i18n from "../i18n";
import axios from "axios";
import {Loading, withAuthentication, withVenuesApi,withCourseContactApi,withCourseGroupsApi,withQualificationsApi,  withCoursePortalApi  } from "cw-styleguide-react";
import {
  ACTION_PUBLISH,
  ACTION_QA,
  ACTION_SAVE,
  ACTION_TRANSLATE, LANGUAGE_CY, LANGUAGE_EN,
  STATUS_AMENDED, STATUS_AWAITING_AMENDMENTS, STATUS_AWAITING_TRANSLATION,
  STATUS_DRAFT, STATUS_EDITED, STATUS_NEW,
  STATUS_PUBLISHED
} from "../constants";


class AssetsProvider extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    // Track the global application state.
    this.state = {
      assets: {
        venues: {
          statuses: [],
          facilitiesAvailable: [],
          learnerSupport: [],
        },
        contacts: {
          statuses: [],
          contactTypeLookup:[]
        },
        courseGroups: {
          courseGroupTypeLookup: [],
          courseGroupType: []
        },
        qualifications: {
          qualificationType: [],
          qualificationLevel: [],
          awardingBody: []
        },
        courses:{
          courseType: [],
          languages: [],
          statuses: [],
          studyMethodHours: [],
          studyMethodTimes: [],
          studyMethodType: [],
          programmes: [],
          qualificationUnknown: []
        },
        translators: []
      },
      loaded: false
    };

    // Bind 'this' inside these function to reference this classes 'this'
    this.processVenuesAssets = this.processVenuesAssets.bind(this);
    this.processContactsAssets = this.processContactsAssets.bind(this);
    this.processQualificationsAssets = this.processQualificationsAssets.bind(this);
    this.getStatusName = this.getStatusName.bind(this);
    this.getCoursesRole = this.getCoursesRole.bind(this);
    this.processCoursesAssets = this.processCoursesAssets.bind(this);
    this.getSaveState = this.getSaveState.bind(this);
    this.getTranslationSaveString = this.getTranslationSaveString.bind(this);
  }

  /**
   * ComponentDidMount.
   */
  async componentDidMount() {

    await Promise.all([
      axios.get(this.props.venuesApiGetEndpoint('venues_api_venues_filters'), {
        headers: {
          'Accept-Language': i18n.language
        }
      }),
      axios.get(this.props.courseContactApiGetEndpoint('course_contact_api_contacts_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_EN
        }
      }),
      axios.get(this.props.courseContactApiGetEndpoint('course_contact_api_contacts_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_CY
        }
      }),
      axios.get(this.props.courseGroupsApiGetEndpoint('course_groups_api_course_groups_filters'), {
        headers: {
          'Accept-Language': i18n.language
        }
      }),
      axios.get( this.props.qualificationsApiGetEndpoint('qualifications_api_qualifications_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_EN
        }
      }),
      axios.get( this.props.qualificationsApiGetEndpoint('qualifications_api_qualifications_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_CY
        }
      }),
      axios.get(this.props.coursePortalApiGetEndpoint('course_portal_api_course_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_EN
        }
      }),
      axios.get(this.props.coursePortalApiGetEndpoint('course_portal_api_course_filters'), {
        headers: {
          'Accept-Language': LANGUAGE_CY
        }
      })
    ])
      .then(response => {
        this.processVenuesAssets(response[0]);
        this.processContactsAssets(response[1], LANGUAGE_EN);
        this.processContactsAssets(response[2], LANGUAGE_CY);
        this.processCourseGroupsAssets(response[3]);
        this.processQualificationsAssets(response[4], LANGUAGE_EN);
        this.processQualificationsAssets(response[5], LANGUAGE_CY);
        this.processCoursesAssets(response[6], LANGUAGE_EN);
        this.processCoursesAssets(response[7], LANGUAGE_CY);

        // Flag the assets have all been successfully loaded.
        this.setState({
          loaded: true
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  /**
   * processCoursesAssets
   * @param response
   */
  processCoursesAssets(response, language) {
    // Load the default filters so we have an array ready to add to.
    let assets = this.state.assets;

    // courseType.
    assets.courses.courseTypeLookup = response.data['courseType'];

    assets.courses.courseType[language] = Object.keys(response.data['courseType']).map(id => ({
      value: id,
      label: response.data['courseType'][id]
    }));

    // languages.
    assets.courses.languages[language] = Object.keys(response.data['languages']).map(id => ({
      value: id,
      label: response.data['languages'][id]
    }));

    // statuses.
    assets.courses.statuses[language] = Object.keys(response.data['statuses']).map(id => ({
      value: id,
      label: this.getStatusName(id)
    }));

    // studyMethodHours.
    assets.courses.studyMethodHours[language] = Object.keys(response.data['studyMethodHours']).map(id => ({
      value: id,
      label: response.data['studyMethodHours'][id]
    }));

    // studyMethodTimes.
    assets.courses.studyMethodTimes[language] = Object.keys(response.data['studyMethodTimes']).map(id => ({
      value: id,
      label: response.data['studyMethodTimes'][id]
    }));

    // studyMethodType.
    assets.courses.studyMethodType[language] = Object.keys(response.data['studyMethodType']).map(id => ({
      value: id,
      label: response.data['studyMethodType'][id]
    }));

    // programmes.
    assets.courses.programmes[language] = Object.keys(response.data.programme).map(id => ({
      value: id,
      label: response.data.programme[id].name,
      fields: {
        summary: response.data.programme[id].summary,
        duration: response.data.programme[id].duration,
        entry: response.data.programme[id].entry,
        startDetails: response.data.programme[id].startDetails,
        additionalDetails: response.data.programme[id].additionalDetails
      }
    }));

    assets.courses.qualificationUnknown[language] = response.data['qualificationUnknown'];

    this.setState({
      assets: assets,
    });
  }

  /**
   * processCourseGroupsAssets
   * @param response
   */
  processCourseGroupsAssets(response) {
    // Load the default filters so we have an array ready to add to.
    let assets = this.state.assets;

    // courseGroupType.
    assets.courseGroups.courseGroupTypeLookup = response.data['courseGroupType'];
    assets.courseGroups.courseGroupType = Object.keys(response.data['courseGroupType']).map(id => ({
      value: id,
      label: response.data['courseGroupType'][id]
    }));


    this.setState({
      assets: assets,
    });
  }

  /**
   * processQualificationsAssets
   * @param response
   */
  processQualificationsAssets(response, language) {
    // Load the default filters so we have an array ready to add to.
    let assets = this.state.assets;

    // qualificationType.
    assets.qualifications.qualificationType[language] = Object.keys(response.data['qualificationType']).map(id => ({
      value: id,
      label: response.data['qualificationType'][id]
    }));

    // qualificationLevel.
    assets.qualifications.qualificationLevel[language] = Object.keys(response.data['qualificationLevel']).map(id => ({
      value: id,
      label: response.data['qualificationLevel'][id]
    }));

    // awardingBody.
    assets.qualifications.awardingBody[language] = Object.keys(response.data['awardingBody']).map(id => ({
      value: id,
      label: response.data['awardingBody'][id]
    }));

    this.setState({
      assets: assets,
    });
  }

  /**
   * processVenuesAssets
   * @param response
   */
  processVenuesAssets(response) {
    // Load the default filters so we have an array ready to add to.
    let assets = this.state.assets;

    // Statuses.
    assets.venues.statuses = Object.keys(response.data['statuses']).map(id => ({
      value: id,
      label:  this.getStatusName(id)
    }));

    // Facilities Available.
    assets.venues.facilitiesAvailable = Object.keys(response.data['facilitiesAvailable']).map(id => ({
      value: id,
      label: response.data['facilitiesAvailable'][id]
    }));

    // Learner Support.
    assets.venues.learnerSupport = Object.keys(response.data['learnerSupport']).map(id => ({
      value: id,
      label: response.data['learnerSupport'][id]
    }));

    this.setState({
      assets: assets,
    });

  }

  /**
   * processContactsAssets
   * @param response
   * @param language
   */
  processContactsAssets(response,language) {
    let assets = this.state.assets;

    assets.contacts =  assets.contacts  ||  [];

    // Statuses.
    assets.contacts.statuses = Object.keys(response.data['statuses']).map(id => ({
      value: id,
      label: this.getStatusName(id)
    }));

    // contactName.
    assets.contacts.contactType = assets.contacts.contactType  || [];

    assets.contacts.contactTypeLookup[language] = response.data['contactType'];

    assets.contacts.contactType[language] = Object.keys(response.data['contactType']).map(id => ({
      value: id,
      label: response.data['contactType'][id]
    }));

    this.setState({
      assets: assets,
    });
  }

  /**
   * getCoursesRole
   * @returns {string}
   */
  getCoursesRole() {
    if (this.props.authentication.hasRole('Courses_CWStaff')   ) {
      return "Courses_CWStaff";
    }
    if (this.props.authentication.hasRole('Courses_Provider')   ) {
      return "Courses_Provider";
    }
    if (this.props.authentication.hasRole('Courses_Translator')   ) {
      return "Courses_Translator";
    }
    if (this.props.authentication.hasRole('Courses_TranslatorManager')   ) {
      return "Courses_TranslatorManager";
    }
  }

  getTranslationSaveString(object, status) {

    return  i18n.exists('local:view.' + object + '.status.overrides.' + this.getCoursesRole() + '.' + status + '.success') ? i18n.t('local:view.' + object + '.status.overrides.' + this.getCoursesRole() + '.' + status + '.success') : i18n.t('local:view.' + object + '.status.defaults.' + status + '.success')
  }

  /**
   * getStatusName
   * @param status
   * @returns {*}
   */
  getStatusName(status) {
    return this.props.t('local:statuses.' + this.getCoursesRole() + '.' + status)
  }

  /**
   * Is the status one of the statuses that implies the venue has a published version.
   * @param status
   * @returns {boolean}
   */
  hasPublished(status) {
    // @todo use constants
    let publishedStatuses = ["267040003", "267040004", "267040005", "267040006"];
    return publishedStatuses.includes(status);
  }

  /**
   * getSaveState
   * @param status
   * @param action
   * @returns {string|*}
   */
  getSaveState(status, action) {
    switch (action) {
      case ACTION_SAVE:
        // @todo use .anyRole
        if (this.props.authentication.hasRole('Courses_CWStaff') || this.props.authentication.hasRole('Courses_Provider') || this.props.authentication.hasRole('Courses_Manager')) {
          if (this.hasPublished(status)) {
            return STATUS_AMENDED
          } else {
            return STATUS_DRAFT
          }
        } else if (this.props.authentication.hasRole('Courses_Translator') || this.props.authentication.hasRole('Courses_TranslatorManager')) {
         return status;
        }
        break;
      case ACTION_PUBLISH:
        return STATUS_PUBLISHED;
      case ACTION_QA:
        if (this.hasPublished(status)) {
          return STATUS_EDITED;
        } else {
          return STATUS_NEW;
        }
      case ACTION_TRANSLATE:
        if (this.hasPublished(status)) {
          return STATUS_AWAITING_AMENDMENTS;
        } else {
          return STATUS_AWAITING_TRANSLATION;
        }
      default:
        console.log('WARNING NO SAVE STATUS MATCH');
        return status;
    }
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    if (!this.state.loaded) {
      return <Loading text={this.props.t('local:app.loading')}/>
    }
    return (
      <AssetsContext.Provider value={{
        assets:this.state.assets,
        getStatusName: this.getStatusName,
        getSaveState: this.getSaveState,
        getTranslationSaveString: this.getTranslationSaveString
      }} >
        {this.props.children}
      </AssetsContext.Provider>
    );
  }
}

export default withCoursePortalApi(process.env)(withQualificationsApi(process.env)(withCourseGroupsApi(process.env)(withCourseContactApi(process.env)(withVenuesApi(process.env)(withAuthentication(withTranslation('local')(AssetsProvider)))))));
